// ============================================================================
// FSA SIGNATURE WORKFLOW ENDPOINTS
// ============================================================================

import { buildEndpoint } from '../base.endpoints';

const FIRMS_BASE       = '/FsaAuditFirms';
const PARTNERS_BASE    = '/FsaAuditPartners';
const DIRECTORS_BASE   = '/FsaDirectorSignatories';
const PANELS_BASE      = '/FsaEngagementSignaturePanels';

export const fsaAuditFirmEndpoints = {
  list:   () => buildEndpoint(FIRMS_BASE),
  byId:   (id: string | number) => buildEndpoint(`${FIRMS_BASE}/${id}`),
  create: () => buildEndpoint(FIRMS_BASE),
  update: (id: string | number) => buildEndpoint(`${FIRMS_BASE}/${id}`),
  remove: (id: string | number) => buildEndpoint(`${FIRMS_BASE}/${id}`),
};

export const fsaAuditPartnerEndpoints = {
  list:   () => buildEndpoint(PARTNERS_BASE),
  byId:   (id: string | number) => buildEndpoint(`${PARTNERS_BASE}/${id}`),
  create: () => buildEndpoint(PARTNERS_BASE),
  update: (id: string | number) => buildEndpoint(`${PARTNERS_BASE}/${id}`),
  remove: (id: string | number) => buildEndpoint(`${PARTNERS_BASE}/${id}`),
};

export const fsaDirectorSignatoryEndpoints = {
  list:   () => buildEndpoint(DIRECTORS_BASE),
  byId:   (id: string | number) => buildEndpoint(`${DIRECTORS_BASE}/${id}`),
  create: () => buildEndpoint(DIRECTORS_BASE),
  update: (id: string | number) => buildEndpoint(`${DIRECTORS_BASE}/${id}`),
  remove: (id: string | number) => buildEndpoint(`${DIRECTORS_BASE}/${id}`),
  /** Engagements holding this director in their own list or signature panel. */
  usage:  (id: string | number) => buildEndpoint(`${DIRECTORS_BASE}/${id}/usage`),
};

export const fsaEngagementSignaturePanelEndpoints = {
  byEngagement:        (engagementId: string) => buildEndpoint(`${PANELS_BASE}/by-engagement/${engagementId}`),
  carryForwardDraft:   (engagementId: string) => buildEndpoint(`${PANELS_BASE}/by-engagement/${engagementId}/carry-forward`),
  upsert:              () => buildEndpoint(PANELS_BASE),
  remove:              (id: string | number) => buildEndpoint(`${PANELS_BASE}/${id}`),
};
